export default __webpack_public_path__ + "static/media/Point-to-Point Automated Urban Shuttle Service.0008651c.pdf";